import styled from 'styled-components';
import TrackedButton from '../../../components/TrackedButton';
import RemoveIcon from '../../../components/icons/Remove';
import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCloseButton = styled(TrackedButton).withConfig({
  displayName: "HelpTooltipCloseButton__StyledCloseButton",
  componentId: "sj76c-0"
})(["right:16px;top:12px;position:absolute;background:transparent;border:none;"]);
export function HelpTooltipCloseButton({
  onClick
}) {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(StyledCloseButton, {
    onClick: onClick,
    "data-test-id": "help-tooltip-close-button",
    children: /*#__PURE__*/_jsx(RemoveIcon, {
      style: {
        width: '12px'
      },
      color: theme.color['icon-core-subtle']
    })
  });
}
export default HelpTooltipCloseButton;